import React, { useEffect } from "react";
export function TextColumnFilter({ column: { id, filterValue, setFilter, readable }, style, className, }) {
    const [value, setValue] = React.useState(filterValue || "");
    const handleChange = (event) => {
        setValue(event.target.value);
        setFilter(event.target.value);
    };
    // ensure that reset loads the new value
    useEffect(() => {
        setValue(filterValue || "");
    }, [filterValue]);
    return (React.createElement("input", { style: style, className: className, placeholder: "Filter", autoComplete: "off", "aria-label": `Filter by ${readable || id}`, type: "text", name: id, value: value, onChange: handleChange, onBlur: (e) => {
            setFilter(e.target.value || undefined);
        } }));
}
//# sourceMappingURL=TextColumnFilter.js.map